import BaseApiService from './BaseApiService';

class DrugBrandApiService extends BaseApiService {
    constructor() {
        super('tags');
    }

    async getAll() {
        const response = await this.request({ method: 'get', url: '' });
        return response && response.tags ? response.tags : [];
    }
}

export default new DrugBrandApiService();
